import { useRef } from "react";
import { useDispatch } from "react-redux";
import { setSubmitFinished } from "../ducks/checkoutSlice";
import useToast from "./useToast";

/**
 * Envia o pedido do autoatendimento com o tratamento de erro comum aos
 * submodos: erro que a API já explicou ao cliente (isUserReadable) não ganha
 * um segundo aviso, e o botão volta a ficar disponível.
 */
export default function useSubmitSelfcheckout(submit) {
  const dispatch = useDispatch();
  const { toastError } = useToast();

  // O isSubmitting do store só liga depois do primeiro await do envio; até lá,
  // um segundo disparo (duplo toque, leitura repetida da comanda) passaria.
  const inFlight = useRef(false);

  return async () => {
    if (inFlight.current) return;
    inFlight.current = true;

    try {
      await submit();
    } catch (err) {
      console.error(err);
      if (!err.isUserReadable) {
        toastError("Erro desconhecido tentar enviar pedido.", {
          autoClose: 6000,
        });
      }
      dispatch(setSubmitFinished());
    } finally {
      inFlight.current = false;
    }
  };
}
